import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'booleanResult',
  standalone: false,
})
export class BooleanResultPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    return value === true ? 'Oui' : 'Non';
  }
}